module.exports = __webpack_public_path__ + "media/images/icons/credit_card/jcb-77693d71cd21be577c2368cca2c89302.png";